var React = require('react');
const { NotificationItem } = require('./NotificationItem');
const { WelcomeNotification } = require('./NotificationItem');
const { connect } = require('react-redux');
const { withTranslation, useTranslation } = require('react-i18next');
const Spinner = require('../Spinner.jsx');

const SyncIndicator = ({ size }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      padding: size === 'large' ? '100px 48px 0' : '8px 0',
    }}
  >
    <Spinner size={'medium'} />
  </div>
);

const NotificationsList = (props) => {
  const { t } = useTranslation();
  const notifications = props?.notificationsData || [];
  const noNotificationsToPresent =
    notifications.length === 0 && !props.shouldDisplayWelcomeNotification;
  // Sync spinner only belongs to the "nothing loaded yet" case — a filter
  // that legitimately matches zero notifications is not a loading state.
  const isSyncingWithNoFeed = props.isSyncing && !props.hasAnyFeedItems;

  const setWelcomeNotificationDisplay = () => {
    props.updateUserWelcomeNotification();
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {props.shouldDisplayWelcomeNotification ? (
        <WelcomeNotification
          updateUserWelcomeNotification={setWelcomeNotificationDisplay}
        />
      ) : null}
      {notifications.map((notificationObj, index) => {
        return (
          <NotificationItem
            onCloseClicked={props.onCloseClicked}
            updateUserMetaData={props.updateUserMetaData}
            key={notificationObj.id || index}
            index={index}
            notificationData={notificationObj}
          />
        );
      })}
      {noNotificationsToPresent ? (
        isSyncingWithNoFeed ? (
          <SyncIndicator size='large' />
        ) : (
          <div
            style={{
              marginTop: '160px',
              fontSize: '24px',
              color: '#919DB4',
              textAlign: 'center',
              marginLeft: '48px',
              marginRight: '48px',
              lineHeight: '100%',
            }}
          >
            {t('no_notifications')}
          </div>
        )
      ) : (
        <div style={{ height: '96px' }} />
      )}
    </div>
  );
};

const mapStateToProps = function (state) {
  return {
    userData: state.authentication_data.user_data,
  };
};

module.exports = connect(mapStateToProps)(withTranslation()(NotificationsList));
